import styled from 'styled-components';

export default styled.h1`
  font-size: 1.75rem;
  text-transform: uppercase;
`;
